module.exports = __webpack_public_path__ + "img/fourth_cloud_color.4b7a2f96.png";